import { ButtonHTMLAttributes, RefObject } from "react";

function SecondaryButton({
  innerRef,
  children,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  innerRef?: RefObject<HTMLButtonElement>;
}) {
  return (
    <button
      type="button"
      className="mt-3 inline-flex w-full justify-center rounded-3xl bg-white px-6 py-2 text-lg font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 transition-all hover:bg-gray-50 sm:mt-0 sm:w-auto"
      ref={innerRef}
      {...props}
    >
      {children}
    </button>
  );
}

export default SecondaryButton;
